import React from 'react';
import ReactDOM from 'react-dom';

import Types from './common/Types.jsx';
import { Body } from './layout/Page.jsx';

if (typeof(global) === 'undefined') {
    global = window;
}
global.React = React;
global.ReactDOM = ReactDOM;
global.Components = Types.Block.getAllComponents();
global.Components.Page.Body = Body;